import React from 'react';
import { Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import { useTranslation } from 'react-i18next';

import CommonModalButton from '../../../form-components/CommonModalButton';
import {
  ModalBox,
  ModalHeader,
  ModalTitle,
  ModalBody,
  SectionTitle,
  StepList,
  GuideImage,
  NoticeBox,
  NoticeTitle,
  NoticeText,
  NoticeWarn,
  EmailBox,
  EmailLabel,
  EmailValue,
  ContactBox,
  ContactLabel,
  ContactValue,
  ModalFooter,
  DownloadButton,
} from './SmsSenderVerifyGuideModalStyled';

// 문의 전화 (발신번호 인증 관련 고객 문의)
const CONTACT_PHONE = '02-2295-8220';

// 정적 자산 (public/sms-sender/)
const GUIDE_IMAGE = `${process.env.PUBLIC_URL || ''}/sms-sender/verification-guide.jpg`;
const DELEGATION_FORM = `${process.env.PUBLIC_URL || ''}/sms-sender/delegation-form.doc`;
const SUBMIT_EMAIL = 'bodyswitch.kor@gmail.com';

const SmsSenderVerifyGuideModal = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox>
        <ModalHeader>
          <ModalTitle>{t('발신번호 인증 안내')}</ModalTitle>
          <IconButton onClick={onClose} size="small" sx={{ color: '#fff' }}>
            <CloseIcon />
          </IconButton>
        </ModalHeader>

        <ModalBody>
          <SectionTitle>{t('인증 절차')}</SectionTitle>
          <StepList>
            <li>{t('아래 표에서 명의자·번호형태에 맞는 제출서류를 확인하고 준비합니다.')}</li>
            <li>{t('타사 명의 등 위임이 필요한 경우 위임장 양식을 다운로드해 작성합니다.')}</li>
            <li>
              {t('준비한 서류를 아래 이메일로 보냅니다.')} ({SUBMIT_EMAIL})
            </li>
            <li>{t('본사 확인 후 인증이 완료되면 해당 번호로 문자 발송이 가능합니다.')}</li>
          </StepList>

          <SectionTitle>{t('명의자·번호형태별 제출서류')}</SectionTitle>
          <GuideImage src={GUIDE_IMAGE} alt={t('발신번호 등록서류 안내')} />

          <NoticeBox>
            <NoticeTitle>
              {t('* 당사와 계약된 사업자 명의의 발신번호가 아닌 경우')}
            </NoticeTitle>
            <NoticeText>
              {t(
                '발신번호 통신가입증명원 + 개인명의일 때는 신분증 사본 + 위임장(첨부 양식 참고) + 신청자 재직증명서(당사 계약업체 직원 최초 1회) + 총 4개가 필요합니다.',
              )}
            </NoticeText>
            <NoticeWarn>
              {t('통신가입증명원은 개인정보 마스킹(***)되어 있지 않은 서류로 준비')}
            </NoticeWarn>
          </NoticeBox>

          <EmailBox>
            <EmailLabel>{t('서류 제출 이메일')}</EmailLabel>
            <EmailValue>{SUBMIT_EMAIL}</EmailValue>
          </EmailBox>

          <ContactBox>
            <ContactLabel>{t('문의 전화')}</ContactLabel>
            <ContactValue>{CONTACT_PHONE}</ContactValue>
          </ContactBox>
        </ModalBody>

        <ModalFooter>
          <DownloadButton
            component="a"
            href={DELEGATION_FORM}
            download="회신(발신)번호 위임장.doc"
            startIcon={<DownloadIcon />}>
            {t('위임장 양식 다운로드')}
          </DownloadButton>
          <CommonModalButton variant="cancel" onClick={onClose}>
            {t('닫기')}
          </CommonModalButton>
        </ModalFooter>
      </ModalBox>
    </Modal>
  );
};

export default SmsSenderVerifyGuideModal;
